// extracted by mini-css-extract-plugin
export var adjacentSlide = "_lz-9";
export var arrowButtonContainer = "_lz-5";
export var arrowButtonIcon = "_lz-6";
export var carouselArrowButton = "_lz-2";
export var carouselElementContainer = "_lz-1";
export var currentSlide = "_lz-8";
export var left = "_lz-3";
export var otherSlide = "_lz-a";
export var productCarouselContainer = "_lz-0";
export var right = "_lz-4";
export var sliderOverflow = "_lz-7";